import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from "@sentry/angular-ivy";
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

Sentry.init({
  dsn: "https://7087f04850194a9a796c91a26addbf89@o4507106640134144.ingest.us.sentry.io/4507129609584640",
  environment: environment.env_name,

  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],

  tracesSampleRate: environment.production ? 0.1 : 0.01,
  tracePropagationTargets: ["localhost", environment.API_URL],
  replaysSessionSampleRate: 0.05,
  replaysOnErrorSampleRate: 0.5,

  ignoreErrors: [
    'performanceMetrics',
    'cspreport',
    'IdpIFrameHttp',
    'accounts.google.com',
    'Blocked a frame with origin',
    'SecurityError: Blocked a frame'
  ],

  beforeSend(event, hint) {
    const error = hint?.originalException as Error;

    if (error?.message) {
      if (error.message.includes('Blocked a frame with origin') ||
          error.message.includes('SecurityError: Blocked a frame')) {
        return null;
      }
    }

    return event;
  }
});

enableProdMode();

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(() => console.log('Bootstrap success'))
  .catch((err) => console.error(err));
